<template>
  <button
    data-toggle="tooltip"
    title="Edit"
    class="outline-none focus:outline-none active:outline-none"
    :class="[
      'badge',
      { 'badge-success': stage.active },
      { 'badge-danger': !stage.active },
    ]"
    :disabled="activeLoading"
    @click.prevent="switchStatus"
  >
    <span
      v-if="activeLoading"
      class="spinner-border spinner-border-sm"
      role="status"
    >
      <i class="sr-only">Loading...</i>
    </span>

    <span v-else class="flex items-center gap-[5px]">
      <span
        class="w-[10px] h-[10px] rounded-[1px]"
        :style="{
          backgroundColor: stage.active ? '#16a249' : '#EF5253',
        }"
      ></span>
      <span class="text-[12px] font-normal leading-[16.94px]">{{
        stage.active ? "Active" : "Inactive"
      }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: "SwitchStageStatus",
  props: ["stage"],

  data() {
    return {
      activeLoading: false,
    };
  },

  methods: {
    async switchStatus() {
      this.activeLoading = true;

      try {
        const response = await this.$http.put(
          "/PurchaseOrders/orderStage/update/" +
            this.stage.id +
            "/" +
            !this.stage.active
        );

        if (response.ok && response.status === 200) this.$emit("onComplete");
        this.activeLoading = false;
      } catch (error) {
        this.activeLoading = false;
      }
    },
  },
};
</script>
